export default {
  title: "Regra tipo 8 - Colaboradores, perfis, áreas elegíveis",
  subtitle: "Quais os colaboradores que são elegíveis para o rateio Indireto?",
  token: "collab_eligibility",
  orderBy: "value_b",
  convert: {
    param: "value_c",
    method: "eligibility_to_status",
  },
  tables: [
    {
      type: "general",
      title: "Regra geral",
      actions: "edit_remove",
      columns: [
        {
          label: "CC Origem",
          key: "value_a",
          placeholder: "Todos",
          value: "*",
        },
        {
          label: "Nome Origem",
          key: "value_a",
          placeholder: "Todos",
          value: "*",
          convert: {
            method: "project_id_to_id_name",
          },
        },
        {
          label: "CC Destino",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
        },
        {
          label: "Nome Destino",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
          convert: {
            method: "project_id_to_id_name",
          },
        },
        {
          label: "Status",
          key: "value_c",
          type: "status",
        },
      ],
      data: [],
    },
  ],
  drawer: {
    title: {
      insert_label: "Adicionar Regra",
      update_label: "Editar Regra",
    },
    subtitle: "Regra tipo 8 - Colaboradores, perfis, áreas elegíveis",
    form: [
      {
        label: "Informe o Centro de Custo de origem:",
        type: "list",
        key: "value_a",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Informe o Centro de Custo de destino:",
        type: "list",
        key: "value_b",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Status:",
        type: "status",
        key: "value_c",
        placeholder: "",
        value: "*",
        visible: false,
        convert: {
          method: "boolean_to_eligibility_status",
        },
      },
    ],
  },
};
